export default function roomEventListener(room) {
    return store => {
        room.addEventListeners({
            room_call_changeCallType: e => {
                store.commit('call/changeCallType', e.data);
            },
            room_call_userMicVolume: e => {
                store.commit('user/setUserMicVolume', e.data);
            },
            // mixerConnectionStats: e => {
            //     store.commit('call/mixerConnectionStats', e.data);
            // },
            room_call_changeVideoQuality: e => {
                store.commit('call/changeVideoQuality', e.data)
            },
            room_call_changeWebinarType: e => {
                store.commit('call/CHANGE_WEBINAR_TYPE', e.data)
            },
            room_call_changeHideRoomGroupUserInFilmArea: e => {
                store.commit('call/changeHideRoomGroupUserInFilmArea', e.data)
            }
        });
    }
}
